import React, { createContext, useContext, ReactNode, useState, useEffect } from "react";

// ✅ Import your images directly so you can visually see what file each one is.
import HAK from "@/assets/imgs/officers/HAK.webp";
import AOA from "@/assets/imgs/officers/AOA.webp";
import BPE from "@/assets/imgs/officers/BPE.webp";
import GAD from "@/assets/imgs/officers/GAD.webp";
import HME from "@/assets/imgs/officers/HME.webp";
import KSE from "@/assets/imgs/officers/KSE.webp";
import MOW from "@/assets/imgs/officers/MOW.webp";
import NAS from "@/assets/imgs/officers/NAS.webp";
import RND from "@/assets/imgs/officers/RND.webp";
import SSE from "@/assets/imgs/officers/SSE.webp";
import EAG from "@/assets/imgs/officers/EAG.webp";
import RAG from "@/assets/imgs/officers/RAG.webp";
import DAS from "@/assets/imgs/officers/DAS.webp";
import JKB from "@/assets/imgs/officers/JKB.jpeg";
import VMH from "@/assets/imgs/officers/VMH.jpeg";
import SAP from "@/assets/imgs/officers/SAP.jpeg";
import GYE from "@/assets/imgs/officers/GYE.jpeg";
import MMK from "@/assets/imgs/officers/MMK.jpg";
import PBO from "@/assets/imgs/officers/PBO.jpg";

// Define the leader structure
export interface Leader {
  id: string;
  name: string;
  roles: string[];
  bio?: string;
  image?: string;
  socials?: {
    facebook?: string;
    instagram?: string;
    twitter?: string;
    linkedin?: string;
  };
}

// Context type
interface LeadershipContextType {
  leaders: Leader[];
  loading: boolean;
}

// Create the context
const LeadershipContext = createContext<LeadershipContextType>({
  leaders: [],
  loading: true,
});

export const LeadershipProvider = ({ children }: { children: ReactNode }) => {
  const [leaders, setLeaders] = useState<Leader[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Normally you could fetch this from Firestore or an API,
    // but we’ll use local static data for now.
    const leaderData: Leader[] = [
      {
        id: "0",
        name: "Rev Emmanuel Agyemang",
        roles: ["Leicester Area Head", " Leicester District Minister"],
        image: EAG,
      },
      {
        id: "0b",
        name: "Mrs. Rita Agyemang",
        roles: ["Area Head's Wife"],
        image: RAG,
      },
      {
        id: "1",
        name: "Elder Hayford Akowuah",
        roles: ["Presiding Elder"],
        image: HAK,
      },
      {
        id: "2",
        name: "Elder Horatio Mends",
        roles: ["Elder", "Men's Ministry Lead"],
        image: HME,
      },
      /*{
        id: "3",
        name: "Elder Noble Asare",
        roles: ["Elder", "Children's Ministry Lead", "Evangelism Ministry Lead"],
        image: NAS,
      },*/
      {
        id: "4",
        name: "Elder Kwasi Senya",
        roles: ["Elder"],
        image: KSE,
      },
      {
        id: "5",
        name: "Elder Michael Owusu",
        roles: ["Media Team Lead"],
        image: MOW,
      },
      {
        id: "6",
        name: "Elder Jesse Boateng",
        roles: ["Elder"],
        image: JKB
      },
      {
        id: "7",
        name: "Deacon George Aduhene",
        roles: ["Deacon"],
        image: GAD,
      },
      /*{
        id: "8",
        name: "Deacon Felix Adu Agyekum",
        roles: ["Deacon"],
      },*/,
      {
        id: "10",
        name: "Deaconess Victoria Marmon-Halm",
        roles: ["Deaconess"],
        image: VMH
      },
      {
        id: "9",
        name: "Deaconess Anabel Owusu",
        roles: ["Designated Safeguarding Lead"],
        image: AOA,
      },
      {
        id: "11",
        name: "Deaconess Salomey Appiah",
        roles: ["Deaconess"],
        image: SAP
      },
      {
        id: "12",
        name: "Deaconess Ruth Narh-Davis",
        roles: ["Deaconess"],
        image: RND,
      },
      {
        id: "13",
        name: "Deaconess Phyilis Boateng",
        roles: ["Deaconess"],
        image: PBO,
      },
      {
        id: "14",
        name: "Deaconess Grace Yeboah",
        roles: ["Deaconess"],
        image: GYE
      },
      {
        id: "15",
        name: "Deaconess Mavis Masmos-Kyei",
        roles: ["Deaconess"],
        image: MMK
      },
      {
        id: "16",
        name: "Deaconess Sarah Senya",
        roles: ["Deaconess"],
        image: SSE,
      },
    ];

    setTimeout(() => {
      setLeaders(leaderData);
      setLoading(false);
    }, 300);
  }, []);

  return (
    <LeadershipContext.Provider value={{ leaders, loading }}>
      {children}
    </LeadershipContext.Provider>
  );
}
// Custom hook to use leadership data
export const useLeadership = () => useContext(LeadershipContext);
